import { V2_API_PREFIX } from '@constants/urls'

export const API_HUBSPOT_EVENT_URL = `${V2_API_PREFIX}hubspot/event/`
